import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {Choice, ChoiceSelection} from '../../../shared/model/poll.model';

@Component({
  selector: 'app-poll-resolution-option',
  templateUrl: './poll-resolution-option.component.html',
  styleUrls: ['./poll-resolution-option.component.less', '../../poll-detail-choice-plurinominal/poll-detail-choice-plurinominal.component.less'],
})
export class PollResolutionOptionComponent implements OnInit {

  @Input() choice: Choice;
  @Input() isMobile: boolean;
  @Input() index: number;
  @Output() selected = new EventEmitter<ChoiceSelection>();
  imageAsset = 'assets/pouce_levee_resolution.svg';
  shouldShow = true;

  actionVote() {
    this.selected.emit(new ChoiceSelection(this.choice, this.index, null));
    }

  ngOnInit() {
    const languageKey = 'userLanguage';
    const userLang = navigator.language || navigator[languageKey];
    this.imageAsset = 'assets/resolution_unselected.svg';
    switch (this.index) {
      case 0: {
        this.imageAsset = 'assets/pouce_levee_resolution.svg';
        switch (userLang.substring(0, 2)) {
          case 'fr': { this.choice.text = 'Pour'; break; }
          case 'es': { this.choice.text = 'A favor'; break; }
          default: { this.choice.text = 'For'; }
        }
        break;
      }
      case 1: {
        this.imageAsset = 'assets/pouce_baissee_orange.svg';
        switch (userLang.substring(0, 2)) {
          case 'fr': { this.choice.text = 'Contre'; break; }
          case 'es': { this.choice.text = 'En contra'; break; }
          default: { this.choice.text = 'Against'; }
        }
        break;
      }
      case 2: {
        this.imageAsset = 'assets/abstention_resolution.svg';
        switch (userLang.substring(0, 2)) {
          case 'es': { this.choice.text = 'Abstención'; break; }
          default: { this.choice.text = 'Abstention'; }
        }
        break;
      }
      case 3: {
        this.shouldShow = false;
        break;
      }
      default:
        break;
    }
  }
}
